export default "__VITE_PUBLIC_ASSET__11305a3c__"